import React from "react";
import TableRow from "./tableRow";
import "./index.css";

const NewCommunityRequest = ({
  data,
  onToggleModerator,
  onActivateNewCommunityRequest,
  onRemoveNewCommunityRequest,
  isLoading
}) => {
  const headers = {
    "Community Name": "tName",
    "Community Type": "tType",
    "Community Address": "tAddress",
    Description: "tDescription",
    "First/Last Name": "tFirstLastName",
    Email: "email",
    "Phone No.": "phoneNo",
    "Zip Code": "zipCode",
    "Time (UTC)": "tenantCreatedTimeUTC",
    Image: "Uimage",
    Moderator: "isPMStatus",
    "Activation Request": "emailCheck",
    Activate: "",
    Dismiss: "tenantId", // Used for delete action
  };

  console.log(`communityRequestdata:`, data);

  if (isLoading) {
    return (
      <div className="loader-container">
        <p>Loading dashboard data...</p>
      </div>
    );
  }

  return (
    <div className="responsive-table-container">
      <table className="responsive-table">
        <thead>
          <tr>
            {Object.keys(headers).map((header, idx) => (
              <th key={idx}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <TableRow
              key={row.tenantId}
              row={row}
              rowIndex={rowIndex}
              headers={headers}
              onToggleModerator={onToggleModerator}
              onActivateNewCommunityRequest={onActivateNewCommunityRequest}
              onRemoveNewCommunityRequest={onRemoveNewCommunityRequest}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default NewCommunityRequest;
